import React, { useState, useEffect } from "react";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { TimezoneUpdate } from "./timezoneUpdate";
import { ConfirmationDialog } from "../../common/confirmationDialog";
import { AddNew } from "../../uiControls/addNew";
import * as utils from "../../common/utils";

const timezoneColumns = [
  {
    label: "Timezone",
    keyField: "timezoneKey",
    dataField: "name",
    dataType: "string",
  },
  {
    label: "Description",
    keyField: "timezoneKey",
    dataField: "description",
    dataType: "string",
  },
  {
    label: "GMT Diff.",
    keyField: "timezoneKey",
    dataField: "offset",
    dataType: "string",
  },
  {
    label: "Status",
    keyField: "timezoneKey",
    dataField: "active",
    dataType: "boolean",
    minWidth: 20,
    maxWidth: 20,
  },
  {
    label: "",
    keyField: "timezoneKey",
    dataField: "timezoneKey",
    dataType: "number",
    minWidth: 20,
    maxWidth: 20,
  },
];

const timezoneSearchColumns = ["name", "description", "countryName"];

export const TimezoneConfig = () => {
  const [updateOpen, setUpdateOpen] = useState(false);
  const [timezoneOffsets, setTimezoneOffsets] = useState([]);
  const [timezoneEdit, setTimezoneEdit] = useState(null);
  const [timezoneAttributes, setTimezoneAttributes] = useState({
    timezoneKey: 0,
    name: "",
    countryName: "",
    description: "",
    isDst: false,
    active: true,
    diff: 0,
    timezoneOffsetTitle: {},
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationDialogAttributes, setConfirmationDialogAttributes] =
    useState({});

  const { sendRequest: fetchTimezoneDetails } = useHttpRequests();
  const { sendRequest: fetchTimezoneOffsets } = useHttpRequests();

  useEffect(() => {
    const getTimezoneResponse = (obj) => {
      if (!obj || !obj.isSuccess || obj.errorResponse) {
        console.log("Timezone Offset fetch response returns error");
        return;
      }
      const timezoneOffsetOptions = [];
      obj["offsets"].forEach((timezoneOffsetObj) => {
        timezoneOffsetOptions.push({
          value: timezoneOffsetObj["diff"],
          label: timezoneOffsetObj["offset"],
        });
      });

      setTimezoneOffsets(timezoneOffsetOptions);
    };
    fetchTimezoneOffsets(
      { url: "Timezones/Offsets", method: "GET", header: true },
      getTimezoneResponse
    );
  }, []);

  const timezoneEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      //alert("Are you sure to discard your changes?");
      //TODO: confirmation for data loss
      return false;
    }

    const getTimezoneDetails = (timezoneObj) => {
      if (!timezoneObj || !timezoneObj.isSuccess || timezoneObj.errorResponse) {
        console.log("Timezone fetch response returns error");
        return;
      }

      setTimezoneAttributes({
        timezoneKey: timezoneObj["timezone"]["timezoneKey"],
        name: timezoneObj["timezone"]["name"],
        description: timezoneObj["timezone"]["description"],
        isDst: timezoneObj["timezone"]["isDst"],
        active: timezoneObj["timezone"]["active"],
        countryName: timezoneObj["timezone"]["countryName"],
        diff: timezoneObj["timezone"]["diff"],
        timezoneOffsetTitle: utils.findStringById(
          timezoneOffsets,
          "value",
          timezoneObj["timezone"]["diff"]
        ),
      });

      setTimezoneEdit(true);
      setUpdateOpen(true);
    };

    fetchTimezoneDetails(
      { url: "Timezones/" + key, method: "GET", header: true },
      getTimezoneDetails
    );
  };

  const changeTimezoneStatus = (e, key, status, name) => {
    e.stopPropagation();
    if (updateOpen || dialogOpen) {
      return false;
    }
    setConfirmationDialogAttributes({
      title: "Timezone status change confirmation!",
      message:
        "Are you sure to mark " +
        (status ? "active" : "inactive") +
        " the " +
        name +
        "?",
      confirmText: "Yes",
      cancelText: "No",
      url: "Timezones/",
      keyField: "timezoneKey",
      key: key,
      status: status,
      messageTitle: name,
    });
    setDialogOpen(true);
  };

  const getUrl = (params) => {
    return "Timezones";
  };

  const timezoneDetailProps = {
    setUpdateOpen,
    timezoneEdit,
    setTimezoneEdit,
    timezoneAttributes,
    timezoneOffsets,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <ConfirmationDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        confirmationDialogAttributes={confirmationDialogAttributes}
      />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              pagging={false}
              columns={timezoneColumns}
              url={getUrl}
              sourceObj="timeZones"
              editHandler={timezoneEditHandler}
              updateOpen={updateOpen}
              searchOnColumns={timezoneSearchColumns}
              changeStatus={changeTimezoneStatus}
              searchPlace="right"
            />

            <AddNew
              onClickCall={() => {
                setTimezoneAttributes({
                  timezoneKey: 0,
                  name: "",
                  description: "",
                  isDst: false,
                  active: true,
                  countryName: "",
                  diff: 0,
                  timezoneOffsetTitle: "",
                });
                setTimezoneEdit(false);
                setUpdateOpen(true);
              }}
            />
          </>
        )}
      </div>

      {updateOpen && (
        <div
          style={{
            display: "flex",
            width: window.innerWidth <= 1366 ? "100%" : "65%",
          }}
        >
          <TimezoneUpdate {...timezoneDetailProps} />
        </div>
      )}
    </div>
  );
};
